if (import.meta.env.MODE == 'development') {
  // patternlib styles are only imported at local dev mode, in production the surrounding site will deliver them
  import('@liebherr/patternlib/dist/patternlib/patternlib.css');
  import('@liebherr/patternlib/www/assets/css/patternlib-fonts.css');
}

// Requires that the @liebherr/patternlib package is installed.
// Calls applyPolyfills and defineCustomElements from the main package internally.
import { PatternLibraryPlugin } from '@liebherr/patternlib-vue';

import WarrantyForm from './views/WarrantyForm.vue';

import { createApp } from 'vue';
import App from './App.vue';
import './style.css';

import { createRouter, createWebHistory } from 'vue-router';
import i18n from './i18n';

const routes = [
  { path: '/', name: 'index', component: WarrantyForm },
  { path: '/:language/:country+', name: 'nondwl', component: WarrantyForm },
  { path: '/:locale+', name: 'dwl', component: WarrantyForm }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

//Install Validation Directive
import { createValidation } from '@liebherr/form-validator-vue';

const ValidationPlugin = createValidation({
  validateOnFocusLoss: false,
  initialValidation: false,
  enablePassiveValidation: true
});

createApp(App)
  .use(i18n)
  .use(router)
  .use(PatternLibraryPlugin)
  .use(ValidationPlugin)
  .mount('#freewarrantyForm');
